import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FaAngleLeft } from "react-icons/fa";
import axios from "axios";
import { Editor } from "@tinymce/tinymce-react";
import Select from "react-select";
import { getAdvisoryDetails } from "../../../../redux/actions/campaignActions";
import ImgChangeIcon from "../../../../assets/images/camera-icon.png";
import Sidebar from "../../../../components/sidebar/Sidebar";
import Navbar from "../../../../components/navbar/Navbar";
import Loader from "../../../../components/Loader/Loader";
import "../../../new/new.scss";

const Viewadvisory = () => {
  let token = localStorage.getItem("accessToken");
  const id = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [countryId, setCountryID] = useState([]);
  const [description, setDescription] = useState("");

  const dispatch = useDispatch();
  const advisoryView = useSelector((state) => state.advisoryView);
  const { advisory } = advisoryView;

  useEffect(() => {
    if (advisoryView) {
      if (advisoryView?.loading !== undefined) {
        setLoading(advisoryView?.loading);
        setCountryID(advisoryView?.advisory?.data?.country_id);
      }
    }
  }, [advisoryView]);

  useEffect(() => {
    // axios
    //   .get(process.env.REACT_APP_API + "get-country")
    //   .then((res) => setData(res.data.data))
    //   .catch((err) => console.log(err));
    getCountry();
  }, []);

  // const countries = [...new Set(data)];
  // countries.sort();

  const getCountry = async () => {
    const res = await axios({
      method: "GET",
      url: process.env.REACT_APP_API + "get-country",
    });

    const data = res?.data?.data;
    const options = data?.map((d) => ({
      value: d?.id,
      label: d?.country_name,
    }));
    setData(options);
  };

  useEffect(() => {
    dispatch(getAdvisoryDetails(token, id));
  }, [dispatch]);

  return (
    <div className="new">
      <Loader isLoading={loading} />
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <span className="backarrow">
            <FaAngleLeft onClick={() => navigate(-1)} />
          </span>
          <h1 className="view-page-tittle">View Advisory</h1>
        </div>
        <div className="bottom">
          <div className="left">
            <div className="profile-pic-div">
              <img
                src={advisory?.data?.profile_pic}
                alt=""
                className="setting-profile"
              />
            </div>
          </div>
          <div className="right">
            <form>
              <div className="formInput">
                <label>First Name</label>
                <input
                  type="text"
                  name="firstname"
                  disabled={true}
                  value={advisory?.data?.firstname}
                  placeholder="Enter First Name"
                />
              </div>
              <div className="formInput">
                <label>Last Name</label>
                <input
                  type="text"
                  name="lastname"
                  disabled={true}
                  value={advisory?.data?.lastname}
                  placeholder="Enter Last Name"
                />
              </div>
              <div className="formInput">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  disabled={true}
                  value={advisory?.data?.email}
                  placeholder="Enter Email"
                />
              </div>
              <div className="formInput">
                <label>Designation</label>

                <select
                  name="profile_designation"
                  disabled={true}
                  value={advisory?.data?.profile_designation}
                >
                  <option value="" disabled selected hidden>
                    Select Designation
                  </option>
                  <option value="accountants">Accountants</option>
                  <option value="lawyers">Lawyers</option>
                  <option value="consulting Company">Consulting company</option>
                </select>
              </div>
              <div className="formInput">
                <label>Country</label>
                {/* <select
                  name="countryPartner"
                  className="sort-by dropdown"
                  disabled={true}
                  value={countryId}
                >
                  <option value="" disabled selected hidden>
                    Select Country
                  </option>
                  {countries.map((items) => (
                    <option key={items.id} value={items.id}>
                      {items.country_name}
                    </option>
                  ))}
                </select> */}
                <Select
                  isMulti={true}
                  options={data}
                  value={countryId?.map(
                    (id) => data?.filter((d) => d.value == id)[0]
                  )}
                  isDisabled={true}
                  // onChange={handleCountry}
                />
              </div>
              <div className="formInput">
                <label>Website</label>
                <input
                  type="text"
                  name="website_url"
                  disabled={true}
                  value={advisory?.data?.website_url}
                  placeholder="Enter Website"
                />
              </div>
              <div className="formInput">
                <label>Twitter</label>
                <input
                  type="text"
                  name="twitter_url"
                  disabled={true}
                  value={advisory?.data?.twitter_url}
                  placeholder="Enter Twitter"
                />
              </div>
              <div className="formInput">
                <label>Linkedin</label>
                <input
                  type="text"
                  name="linkedIn_url"
                  disabled={true}
                  value={advisory?.data?.linkedIn_url}
                  placeholder="Enter Linkedin"
                />
              </div>
              <div className="formInput">
                <label>Youtube</label>
                <input
                  type="text"
                  name="youTube_url"
                  disabled={true}
                  value={advisory?.data?.youTube_url}
                  placeholder="Enter Youtube"
                />
              </div>

              <div className="formInput"></div>
              <div className="formInputDescription">
                <label>Description</label>

                <Editor
                  initialValue="<p>This is the initial content of the editor.</p>"
                  apiKey="4xerbueqmh9h3gt7gkvu7xnlqgntlyv3qlqtcx6kr7du2cl2"
                  init={{
                    selector: "textarea",
                    height: 300,
                    menubar: true,
                    toolbar: "bottom",
                    plugins: [
                      "advlist autolink lists link image charmap print preview anchor",
                      "searchreplace visualblocks code fullscreen",
                      "insertdatetime media table paste code help wordcount",
                      "lists",
                    ],
                    toolbar:
                      "undo redo | formatselect | " +
                      "bold italic backcolor | alignleft aligncenter " +
                      "alignright alignjustify | bullist numlist outdent indent | " +
                      "removeformat | help",
                    content_style:
                      "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                  }}
                  value={advisory?.data?.about_profile}
                  disabled={true}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Viewadvisory;
